<template>
  <div class="nopads">
      <div class="col-12 d-flex justify-content-between align-items-center pb-1">
          <div class="flex-grow-1">
              <h4 class="form-header pointer hover-header" @click.stop="diariesVisible = !diariesVisible">
                  {{ $t('work_report.contract_diary') }} ({{ results.length }})
              </h4>
          </div>
          <div
              v-if="loading"
              id="loader"
              class="spinner-section"
          />
          <div v-else class="ms-2 px-2" @click.stop="diariesVisible = !diariesVisible">
              <font-awesome-icon icon="arrow-down" class="pointer no-focus arrow-icon dont-print hover-header" :class="{ rotated:diariesVisible }"/>
          </div>
      </div>
      <div class="routa-collapse" :class="{ collapsed: diariesVisible }">
        <div class="col-12 d-flex justify-content-end">
            <button class="btn btn-success form-button" @click.stop="addDiary">
                {{ $t('common.add_new')}}
            </button>
        </div>
        <div
          v-if="results && results.length > 0" class="nopads pt-2">
          <contract-diary-list
            :ely-fields="elyFields"
            :results="results"
            @edit="editDiary"
          />
        </div>
      </div>
      <hr class="report-divider nopads">
      <base-modal v-if="contractDiary" hide-footer hide-header size="lg">
          <contract-diary-editor
            v-model="contractDiary"
            :report-list-view="true"
            :pre-selected-contract="contract"
            :show-ely-fields="elyFields"
            @close="close"
            @close-and-update="closeAndUpdate"
          />
      </base-modal>
  </div>
</template>

<script>
import {timeUtils} from "@/components/mixins/TimeUtils";
import {restApi} from "@/components/mixins/RestApiMixin";
import {workManagementHelper} from '@/components/mixins/WorkManagementMixin'
import ContractDiaryList from "@/components/contractreport/ContractDiaryList.vue";
import ContractDiaryEditor from "@/components/contractreport/ContractDiaryEditor.vue";
import BaseModal from "@/components/BaseModal";

export default {
    name: "ContractDiariesReport",
    components: {BaseModal, ContractDiaryEditor, ContractDiaryList},
    mixins: [timeUtils, restApi, workManagementHelper],
    props: {
        searchParams: {
            type: Object,
            default() {
                return null
            }
        },
        elyFields: {
            type: Boolean,
            default: false
        },
        contract: {
            type: Object,
            default() {
                return null
            }
        },
    },
    data: function () {
        return {
            loading: false,
            diariesVisible: false,
            editMode: false,
            contractDiary: null,
            results: [],
            events: "",
            deviations: "",
            date: null,
        }
    },
    watch: {
        searchParams () {
            this.fetchDiaries()
        }
    },
    mounted() {
        this.fetchDiaries()
    },
    methods: {
        fetchDiaries: function () {
            this.results = []
            this.diariesVisible = false
            if (this.searchParams) {
                let mappedParams = {
                    contract: this.contract.id,
                    from: this.searchParams.dateFrom ? this.getDateIsoString(new Date(this.searchParams.dateFrom)) : null,
                    to: this.searchParams.dateTo ? this.getDateIsoString(new Date(this.searchParams.dateTo)) : null,
                }
                this.loading = true
                this.$emit('loading', true)
                this.restFetchParams(this.contractDiaryUrl, mappedParams, this.handleResponse)
            }
        },
        handleResponse: function (response) {
            if (response && response.data) {
                this.results = response.data
            }
            this.loading = false
            this.$emit('loading', false)
        },
        editDiary(diary) {
            this.contractDiary = diary
        },
        addDiary() {
            this.contractDiary = this.newContractDiary()
        },
        close() {
            this.contractDiary = null
        },
        closeAndUpdate() {
            this.contractDiary = null
            this.fetchDiaries()
        }
    }
}
</script>
